<template>
  <div class="civilization-detaill">
    <van-sticky>
      <div class="title-require" v-if="require_text">考察要求：{{require_text}}</div>
    </van-sticky>
    <div class="select">
      <van-radio-group v-model="result">
        <van-radio v-for="(item, i) in data" :key="i" :name="item.id" @click="selectRadio(item)">
          <div>{{item.title}}</div>
          <div v-if="item.standard && chosed_id == item.id" class="brief">考察标准：</div>
          <div v-if="item.standard && chosed_id == item.id" class="brief">{{item.standard}}</div>
        </van-radio>
      </van-radio-group>
    </div>
    <div class="btn" @click="toReportPage">上报事件</div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getCateList } from "./api";
export default {
  data() {
    return {
      point_id: "",
      point: "",
      result: "",
      data: [],
      chosed_id:'',
      require_text:'',
    };
  },
  computed: {
    ...mapGetters({
      cateGet: "cate/get",
    }),
    pointData() {
      return this.cateGet("point");
    },
    form() {
      return this.cateGet("form");
    },
    cateContent() {
      return this.cateGet("cateContent");
    },
  },
  watch: {
    // cateContent: {
    //   immediate: true,
    //   handler(v) {
    //     this.result.title = v;
    //   },
    // },
    form: {
      immediate: true,
      handler(v) {
        this.result = v.cate;
      }
    },
    pointData: {
      immediate: true,
      handler() {
        const { id, title } = this.pointData;
        this.point_id = id;
        this.point = title;
        document.title = title;
        console.log("idddd", id);
        this.getCateList(id);
      },
    },
  },
  created() {
    window.scroll(0,0)
    this.require_text = this.$route.query.require;
  },
  methods: {
    selectRadio(data) {
      const { id, title } = data
      this.chosed_id = id
      this.setCateList({ cate: id, content: title });
    },
    ...mapActions({
      setCateList: "cate/setCateList",
    }),
    getCateList(id) {
      let params = {
        version: 2,
        pid: id,
      };
      getCateList(params).then((res) => {
        this.data = res.data.map(
          (item) => {
            return {
              id: item.id,
              title: item.title,
              standard:item.standard
            }
          }
        );
      });
    },
    toReportPage() {
      if (JSON.stringify(this.result) == "{}") {
        this.$toast("请选择考察内容");
        return;
      }
      this.$router.push({
        name: "reportDetail",
        // query: {
        // point_id: this.point_id,
        // point: this.point,
        // cate: id,
        // content: title,
        // },
      });
    },
  },
};
</script>
<style scoped lang="less">
.civilization-detaill {
  width:100%;
  box-sizing: border-box;
  padding: 0 15px 100px;
  .title-require{
    font-size: 18px;
    padding:10px 5px;
    text-align: justify;
    background-color: #fff;
    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.16);
    border-radius:0px 0px 10px 10px;
  }
  .mt-30{
    margin-top:100px;
  }
  .mt-60{
    margin-top:170px;
  }
  .select {
    height: 615px;
    overflow-y: auto;
    .brief{
      font-size:14px;
      color:#666;
      margin-top:5px;
    }
  }
  .title {
    font-size: 20px;
    height: 28px;
    line-height: 28px;
    font-weight: 500;
    color: #333;
    margin-bottom: 42px;
  }
  .van-radio {
    align-items: flex-start;
    text-align: left;
    font-size: 15px;
    color: #333;
    line-height: 23px;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
  }
  .van-radio:last-child {
    border: none;
  }
  .btn {
    position: fixed;
    left: 18px;
    right: 18px;
    bottom: 32px;
    height: 50px;
    color: #fff;
    font-size: 16px;
    line-height: 50px;
    background-color: #206aff;
    text-align: center;
    cursor: pointer;
    margin-top: 20px;
    border-radius: 0.14rem;
  }
}
</style>
